<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-briefcase"></i>
      <h3>Información Laboral</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-briefcase"></i>
      <p>No hay información laboral disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <div class="section">
        <h4 class="section-title">Información del Empleo</h4>
        
        <!-- Primera fila: Empresa, Puesto, Ingreso Mensual -->
        <div class="data-grid top-row">
          <div class="data-item" [class.empty]="!data?.companyName">
            <label>Empresa:</label>
            <span [class]="data?.companyName ? 'value' : 'placeholder'">
              {{ data?.companyName || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.position">
            <label>Puesto:</label>
            <span [class]="data?.position ? 'value' : 'placeholder'">
              {{ data?.position || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.monthlyIncome">
            <label>Ingreso Mensual:</label>
            <span [class]="data?.monthlyIncome ? 'value income' : 'placeholder'">
              {{ formatCurrency(data?.monthlyIncome) }}
            </span>
          </div>
        </div>

        <!-- Segunda fila: Fecha de Contratación, Frecuencia de Pago, Teléfono -->
        <div class="data-grid bottom-row">
          <div class="data-item" [class.empty]="!data?.hiringDate">
            <label>Fecha de Contratación:</label>
            <span [class]="data?.hiringDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.hiringDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.paymentFrequency">
            <label>Frecuencia de Pago:</label>
            <span [class]="data?.paymentFrequency ? 'value' : 'placeholder'">
              {{ data?.paymentFrequency || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.phoneNumber">
            <label>Teléfono de Trabajo:</label>
            <span [class]="data?.phoneNumber ? 'value' : 'placeholder'">
              {{ data?.phoneNumber || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
